import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { List } from 'immutable'
import dompurify from 'dompurify'

import Header from '../WelcomeMessageHeader'
import { ProfileIcon, DismissIcon } from '../icons'
import WelcomeMessageCard from '../WelcomeMessageCard'
import styles from './style.styl'

class WelcomeMessage extends Component {
  static propTypes = {
    title: PropTypes.node,
    message: PropTypes.node,
    children: PropTypes.node,
    users: PropTypes.object,
    backgroundColor: PropTypes.string,
    foregroundColor: PropTypes.string,
    showProfileIcon: PropTypes.bool,
    onProfileClick: PropTypes.func,
    showDismissIcon: PropTypes.bool,
    onDismissClick: PropTypes.func,
    isHTMLPreview: PropTypes.bool,
  }

  static defaultProps = {
    users: List(),
    isHTMLPreview: false,
  }

  renderMenu() {
    const { showProfileIcon, showDismissIcon, onProfileClick, onDismissClick } = this.props
    return [
      showProfileIcon && (<ProfileIcon key="profile" onClick={onProfileClick}/>),
      showDismissIcon && (<DismissIcon key="dismiss" onClick={onDismissClick}/>),
    ].filter(Boolean)
  }

  render() {
    const {
      title,
      users,
      message,
      backgroundColor,
      foregroundColor,
      children,
      isHTMLPreview,
    } = this.props
    return (
      <div className={styles.Container}>
        <WelcomeMessageCard>
          <Header
            title={title}
            users={users}
            backgroundColor={backgroundColor}
            foregroundColor={foregroundColor}
            menu={this.renderMenu()}
          >
            {isHTMLPreview ? <div dangerouslySetInnerHTML={{ __html: dompurify.sanitize(message) }}/> : message }
          </Header>
          {children}
        </WelcomeMessageCard>
      </div>
    )
  }
}

export default WelcomeMessage



// WEBPACK FOOTER //
// ./src/scripts/components/shared/MessagePreviews/WelcomeMessage/WelcomeMessageBuilder/index.js